import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzMicroactionModule } from '@blk/daisy/combinations/microactions';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzCardModule } from '@blk/daisy/modules/cards';
import { DzModalModule } from '@blk/daisy/modules/modals';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { RiskProfileIndicatorModule } from '@ddt-web/models-browsing';
import { faChevronDown, faChevronUp, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import { MiniCompareBarSkeletonComponent } from './mini-compare-bar-skeleton/mini-compare-bar-skeleton.component';
import { MiniCompareBarComponent } from './mini-compare-bar.component';

@NgModule({
	declarations: [
		MiniCompareBarComponent,
		MiniCompareBarSkeletonComponent
	],
	imports: [
		AnalyticsModule,
		CommonModule,
		CwpNgFrameworkModule,
		DzCardModule,
		DzIconModule.withIcons(faChevronUp, faChevronDown, faTimes, faTimesCircle),
		DzButtonModule,
		DzMicroactionModule,
		DzModalModule,
		CwpNgFrameworkModule,
		RiskProfileIndicatorModule,
		SharedModule
	],
	exports: [MiniCompareBarComponent]
})
export class MiniCompareBarModule { }
